import { mutatorAction } from 'satcheljs';
import { getStore, getCopilotChatDrawerState, getInitialState } from '../store/store';
import isPopout from 'owa-popout-v2/lib/utils/isPopout';

/**
 * This function turns on the visibility of the Copilot Chat Drawer.
 *
 * Additionally, this function initializes the state if it doesn't exist already.
 *
 * This function is also an internal pure mutator function,
 * public callers should call orchestrators/openCopilotChatDrawer
 */
export const openCopilotChatDrawerMutator: (targetWindow: Window) => void = mutatorAction(
    'openCopilotChatDrawerMutator',
    (targetWindow: Window) => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (state) {
            state.isShown = true;
        } else {
            const newState = getInitialState(isPopout(targetWindow));
            newState.isShown = true;
            getStore().chatDrawerStateMap.set(targetWindow, newState);
        }
    }
);
